// extracted by mini-css-extract-plugin
export var bodyRow = "_ed-d";
export var cardColumns = "_ed-e";
export var ellipsesOverflow = "_ed-2";
export var flatBottomCorners = "_ed-3";
export var flatTopCorners = "_ed-4";
export var headerActionsDropdown = "_ed-f";
export var headerBottomRow = "_ed-c";
export var headerTopRow = "_ed-b";
export var orderDetailsWrapper = "_ed-0";
export var orderInfoContainer = "_ed-1";
export var productDetails = "_ed-9";
export var productImage = "_ed-5";
export var responsiveTable = "_ed-8";
export var shipmentContainer = "_ed-a";
export var tableBottomLeft = "_ed-6";
export var tableBottomRight = "_ed-7";
export var trackingLink = "_ed-g";